export default {
	welcome: "Bienvenido al ORI",
	subtitle: "Elija cómo desea comenzar",
	registerTemple: "Registrar mi Templo",
	registerTempleDesc: "Soy líder o administrador de un templo y quiero registrarlo en el sistema",
	joinAsMember: "Entrar como Miembro",
	joinAsMemberDesc: "Fui invitado por un templo para formar parte del equipo",
	viewPlans: "Ver planes y precios",
	viewPlansDesc: "Arma tu plan — base más los complementos que quieras — y mira el precio",
	alreadyHaveAccount: "¿Ya tiene una cuenta?",
	login: "Iniciar sesión",
	termsOfUse: "Términos de Uso",
	privacyPolicy: "Política de Privacidad",
	acceptTermsPrefix: "He leído y acepto los",
	acceptTermsMiddle: "y la",
	termsRequired: "Debe aceptar los términos para continuar",
};
